import { Component, OnInit, OnDestroy, ElementRef, NgZone, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AreainfoService } from '../../../services/areainfo.service';
import { SubscriptionService } from '../../../../app/shared/services/subscription.service';
import { DashboardService } from '../../../services/dashboard.service';
import { parse } from 'querystring';
import { Subscription } from 'rxjs/Subscription';
import { CommunityLotModel } from '../../../models/CommunitylotModel';
declare var google: any;
var map;
var infowindow;
var geocoder = new google.maps.Geocoder;

@Component({
  selector: 'app-areainfo',
  templateUrl: './areainfo.component.html',
  styleUrls: ['./areainfo.component.css']
})
export class AreainfoComponent implements OnInit, OnDestroy {
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public readonly visible: string = 'visible';
  public readonly hidden: string = 'hidden';
  _type: string = "restaurant";
  private currentCommunityLot: CommunityLotModel = new CommunityLotModel();
  isAtm: boolean;
  isStore: boolean;
  isHospital: boolean;
  isDisplayMap: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(public ngZone: NgZone,
    public areainfoService: AreainfoService
    , public subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    //set google maps defaults    
    this.zoom = 50;
    this.isAtm = false;
    this.isStore = false;
    this.isHospital = false;
    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotId => {
      if (lotId) {
        this.loadMap(lotId);
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  private getPlaceId(latlng: any) {
    geocoder.geocode({ 'location': latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.currentCommunityLot.placeId = results[0]['place_id'];
        }
      }
    });
  }

  loadMap(lotId: number) {
    this.subscriptions.push(this.areainfoService.getCommunityLotByBuyerId().subscribe(x => {
      if (x && x.communitylot) {
        this.currentCommunityLot = x.communitylot.find(x => x.CommunityLotID == lotId);
        let latlng = new google.maps.LatLng(Number(this.currentCommunityLot.latitude), Number(this.currentCommunityLot.longitude));
        this.isDisplayMap = !(latlng.lat() === 0 && latlng.lng() === 0);
        this.initMap(latlng);//-33.867, 151.195
        this.getPlaceId(latlng);
      }
    }));
  }

  setCurrentCommunityLotMarker(latlng: any) {
    let marker = new google.maps.Marker({
      map: map,
      icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      position: latlng
    });
    let address = this.currentCommunityLot.Address;
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.setContent(address);
      infowindow.open(map, this);
    });
    infowindow.setContent(address);
    infowindow.open(map, marker);
    google.maps.event.addListener(infowindow, 'domready', () => {
        let clickableLink = document.getElementById('externalUrlLink');
      if (clickableLink) {
        clickableLink.addEventListener('click', (e) => {
          if (e.srcElement.parentElement && e.srcElement.parentElement.getElementsByTagName('div').length > 0 &&
            e.srcElement.parentElement.getElementsByTagName('div')['placeId']) {
            let currentPlaceId = e.srcElement.parentElement.getElementsByTagName('div')['placeId'].getAttribute('place-id');
            window.open('https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(this.currentCommunityLot.Address)
              + '&origin_place_id=' + this.currentCommunityLot.placeId +
              '&destination=' + encodeURIComponent(e.srcElement.parentElement.getElementsByTagName('div')[0].textContent)
              + '&destination_place_id=' + currentPlaceId
              , '_blank');
          }
        });
      }

    });
  }

  initMap(latlng: any) {
    if (this.isDisplayMap) {
      map = new google.maps.Map(document.getElementById('map'), {
        center: latlng,
        zoom: 15
      });
      infowindow = new google.maps.InfoWindow();
      let service = new google.maps.places.PlacesService(map);
      service.nearbySearch({
        location: latlng,
        radius: '2000',
        type: [this._type]
      }, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (let i = 0; i < results.length; i++) {
            let marker = new google.maps.Marker({
              map: map,
              position: results[i].geometry.location
            });

            google.maps.event.addListener(marker, 'click', function () {
              let html = '<div>' + results[i].name + '</div><br/><a id="externalUrlLink">View on Google Maps</a><div id="placeId" place-id="' + results[i]["place_id"] + '"></div>';
              infowindow.setContent(html);
              infowindow.open(map, this);
            });
          }
        }
      });
      this.setCurrentCommunityLotMarker(latlng);
    }
  }

  setType(_type: string) {
    this._type = _type;
    this.loadMap(this.subscriptionService.CommunityLotId$.getValue());
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/dashboard/areainfo/areainfo.component.ts